import React from "react";

export function NewAppHeader() {
  return <h1>Register a new application</h1>;
}
